export default {
  extract() {
    const url = new URL(window.location.href);
    const pathUnits = url.pathname.split('/');

    return pathUnits[pathUnits.length - 1];
  }
}
